var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEr20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_47)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_28_47",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_28_47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0024 0.0093689C18.6279 0.0093689 23.9976 5.37915 23.9976 12.0047C23.9976 18.6302 18.6279 24 12.0024 24C5.37685 24 0.00708008 18.6302 0.00708008 12.0047C0.00708008 5.37915 5.3792 0.0093689 12.0024 0.0093689Z",
    fill: "#2E8BF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0048 3.45099V15.4042L17.2573 12.2554L12.0048 3.45099ZM12.0048 20.5584L17.2573 13.0168L12.0048 16.1936V20.5584ZM12.0048 3.45099V15.4042L6.74976 12.2554L12.0048 3.45099Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0048 16.1936V20.5584L6.74976 13.0168L12.0048 16.1936Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_47"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEr20);
export default __webpack_public_path__ + "static/media/er20.0187fc84e9ae7134dd334e8841c0a27e.svg";
export { ForwardRef as ReactComponent };